import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {NotificationService} from "../shared/utils/notification.service";

declare var $: any;

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(
        private router: Router,
        private notificationService: NotificationService) {

    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (sessionStorage.getItem('currentUser')) {
            // logged in so return true
            return true;
        }

        // not logged in so redirect to login page with the return url
        this.router.navigate(['/auth/login'], { queryParams: { returnUrl: state.url }});
        return false;
    }




}


// WEBPACK FOOTER //
// ./src/app/_guards/auth.guard.ts